module.exports = __webpack_public_path__ + "img/pink.475ab991.svg";